import { gql } from '@apollo/client'

export const MUTATION_ADD_TAGS_FOR_EMPLOYEES = gql`
  mutation mutationAddTagsForEmployees($input: AddTagsForEmployeesInput!) {
    addTagsForEmployees(input: $input) {
      items {
        id
        color
        name
        taggable_id
        taggable_type
      }
    }
  }
`
